<script setup>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { ref, watch } from 'vue';

const ROORI_URL = 'https://roori.app/?utm_source=roori&utm_medium=reservation_form&utm_campaign=powered_by_roori';

const ctaList = [
    {head: 'widget.cta_like_form', body: 'widget.cta_like_form_body', cta: 'widget.cta_try_roori'},
    {head: 'widget.cta_simplify_life', body: 'widget.cta_connect_calendar', cta: 'widget.cta_try_roori'},
    {head: 'widget.cta_faster_reservations', body: 'widget.cta_no_chaos_calls', cta: 'widget.cta_try_roori'},
    {head: 'widget.cta_stress_free', body: 'widget.cta_simple_efficient', cta: 'widget.cta_try_roori'},
    {head: 'widget.cta_time_precious', body: 'widget.cta_calendar_only', cta: 'widget.cta_try_roori'},
    {head: 'widget.cta_roori_works', body: 'widget.cta_focus_important', cta: 'widget.cta_try_roori'},
    {head: 'widget.cta_leave_to_us', body: 'widget.cta_modern_solution', cta: 'widget.cta_try_roori'},
    {head: 'widget.cta_never_miss', body: 'widget.cta_smart_reminders', cta: 'widget.cta_try_roori'},
    {head: 'widget.cta_simplify_life', body: 'widget.cta_reservations_work_for_you', cta: 'widget.cta_try_roori'}
];

const randomCta = ctaList[Math.floor(Math.random() * ctaList.length)];

const visible = ref(false);
const countdown = ref(5);
let timer = null;

function openModal() {
    countdown.value = 5;
    visible.value = true;
}

function goNow() {
    clearInterval(timer);
    visible.value = false;
    window.location.href = ROORI_URL;
}

function cancel() {
    clearInterval(timer);
    visible.value = false;
}

watch(visible, (val) => {
    if (val) {
        timer = setInterval(() => {
            countdown.value--;
            if (countdown.value <= 0) {
                clearInterval(timer);
                visible.value = false;
                window.location.href = ROORI_URL;
            }
        }, 1000);
    } else {
        clearInterval(timer);
    }
});
</script>

<template>
    <div
        class="fixed md:bottom-4 max-md:top-0 hover:shadow-lg opacity-90 hover:opacity-100 left-1/2 -translate-x-1/2 z-50
               backdrop-blur-xl bg-roori-blue text-white dark:bg-black/70
               md:shadow-2xl md:rounded-xl
               w-full md:max-w-3xl
               flex items-center gap-3 p-1 md:p-2
               transition-all duration-300 ease-out cursor-pointer"
        @click="openModal"
    >
        <div
            class="bg-roori-logo brightness-[600] grayscale w-[16px] h-[16px] ml-2 bg-center bg-contain bg-no-repeat opacity-90"></div>

        <div class="flex-1 md:flex items-center text-xs md:text-sm text-left leading-tight">
            <span>{{ $t(randomCta.head) }}</span>
            <svg viewBox="0 0 2 2" aria-hidden="true" class="mx-2 inline size-0.5 fill-current">
                <circle r="1" cx="1" cy="1"/>
            </svg>
            <span>{{ $t(randomCta.body) }}</span>
            <span class="ml-1">{{ $t(randomCta.cta) }}</span>
        </div>
        <button
            class="group relative overflow-hidden rounded md:rounded-lg p-1 md:px-5 text-xs font-semibold text-white transition-all duration-300"
        >
            <span class="pi pi-arrow-right !text-sm"></span>
        </button>
    </div>

    <Dialog v-model:visible="visible" modal :closable="false" :draggable="false" class="max-w-sm w-full mx-4">
        <template #header>
            <div class="flex items-center gap-2">
                <div class="bg-roori-logo w-[18px] h-[18px] bg-center bg-contain bg-no-repeat"></div>
                <span class="font-semibold text-sm">roori.app</span>
            </div>
        </template>

        <div class="text-center py-2">
            <p class="text-sm text-gray-600 dark:text-gray-300">
                {{ $t('common.redirect_soon') }}
            </p>
            <div class="mt-4 flex items-center justify-center">
                <div class="w-14 h-14 rounded-full border-4 border-roori-blue flex items-center justify-center">
                    <span class="text-2xl font-bold text-roori-blue">{{ countdown }}</span>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="flex gap-2 justify-end">
                <Button :label="$t('common.cancel')" severity="secondary" size="small" @click="cancel" />
                <Button :label="$t('common.go_now')" size="small" @click="goNow" />
            </div>
        </template>
    </Dialog>
</template>

<style scoped>
button {
    transition: background 0.2s ease-in-out;
}
</style>
